module.exports = {
  DataTable: {
    PluginName: "Tabla",
    style: "Estilo",
    margin: "Margin",
    left: "Izquierda",
    right: "Derecha",
    top: "Superior",
    bottom: "Inferior",
    padding: "Padding",
    border_width: "Ancho de Borde",
    border_style: "Estilo de Borde",
    border_color: "Color de Borde",
    border_radius: "Radio de Borde",
    opacity: "Opacidad",
    title: "Título",
    grid: "Rejilla",
    x_grid: "Rejilla Eje X",
    y_grid: "Rejilla Eje Y",
    line_color: "Color de línea",
    file: "Elegir Archivo",
    Graph: "Ggráfico",
    edit: "Editar",
    options: {
      ascending: "Ascendente",
      descending: "Descendente",
      disableFilter: "Filtro filas",
      disableRowChoice: "Selector nº Filas",
      disablePagination: "Paginación",
      initialPageLength: "Nº Filas/Pág",
      initialSortProp: "Ordenar Por Columna",
      initialOrderProp: "Ordenar de Forma",
      labels: "Etiquetas",
      noDataLabel: "Texto Tabla Vacía",
      noDataLabel_txt: "No Hay Datos",
      pageSizeLabel: "Etiqueta NºFilas / Pág",
      pageSizeLabel_txt: "Filas/Pág",
      searchLabel: "Etiqueta Filtro",
      searchLabel_txt: "Filtrar Filas",
      searchPlaceholder: "Placeholder Filtro",
      searchPlaceholder_txt: "",

      example_name_surname_txt: "Nombre Apellido",
      example_age_txt: "Edad",
      example_country_txt: "País",

      examplename1: "Adriana Cruz",
      examplename2: "Carletta Flores",
      examplename3: "Marion  Gilbert",
      examplename4: "Halil Teksoy",
      examplename5: "Ronald Armstrong",
      examplename6: "Bruce Johnson",
      exampleage1: "25",
      exampleage2: "41",
      exampleage3: "18",
      exampleage4: "34",
      exampleage5: "29",
      exampleage6: "62",
      examplecountry1: "Espana",
      examplecountry2: "Canada",
      examplecountry3: "Austria",
      examplecountry4: "Turquia",
      examplecountry5: "Suiza",
      examplecountry6: "Alemania ",
    },
    or: "O",
    x_axis: "Eje X",
    y_axis: "Eje Y",
    chart_type: "Tipo de Gráfico",
    order_by: "Ordenar Por",
    data_rows: "Filas",
    data_cols: "Columnas",
    key: "Key",
    alert_msg: "Rellena todos los campos de la tabla",
    file_msg: "Hay un problema con el fichero subido",
    confirm: "Confirmar",
    fill_in: "O rellena una tabla",
    show: "Mostrar",
    Row: "Línea",
    row_name: "Nombre De Línea",
    header: {
      options: "Opciones de la tabla",
      origin: "Orígen de los datos",
      preview: "Previsualización",
    },
    inline: {
      add_row: "Añadir fila",
      add_column: "Añadir columna",
      remove_row: "Eliminar fila",
      remove_column: "Eliminar columna",
      import_csv: "Importar CSV",
      done: "Listo",
      header_placeholder: "Encabezado",
    },
    table_settings: {
      title: "Tabla",
      show_search: "Cuadro de búsqueda",
      show_pagination: "Paginación",
      show_row_choice: "Selector de filas por página",
      transparent_bg: "Fondo transparente",
      page_length: "Filas por página",
      sort_column: "Columna de orden",
      sort_none: "Sin ordenar",
      sort_order: "Orden",
      column_n: "Columna {{n}}",
    },
    theme: {
      label: "Tema",
      basic: "Básico",
      striped: "Alternado",
      "rows-only": "Borde solo en filas",
      solid: "Cabecera sólida",
      thick: "Bordes gruesos",
    },
  },
};
